// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2RGfG","noInteraction":"EventWrapper_noInteraction__3gsz5"};